module.exports = __webpack_public_path__ + "img/cloth_g3_pants-04.935a019b.svg";